import React from 'react';
import axios from 'helpers/axios';

import { Form, Container, Title, TextInput, Button, Label, Select } from 'ui/components/styled';
import { useToasts } from 'hooks';
import { ValidationPattern } from 'helpers/form';

export const EditUser = ({ user, onClose, onSuccess }) => {
  const [state, setState] = React.useState({
    firstname: user?.name.first,
    lastname: user?.name.last,
    email: user?.email,
    phone: user?.phone,
    role: user?.roles.includes('admin') ? 'admin' : 'user',
  });
  const [preventSubmit, setPreventSubmit] = React.useState(false);
  const { errorToast, successToast, removeAllToasts } = useToasts();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((state) => ({ ...state, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setPreventSubmit(true);
      const response = await axios.put(`/uext/users/${user?.id}`, {
        name: {
          first: state.firstname,
          last: state.lastname,
        },
        email: state.email,
        phone: state.phone,
        roles: [state.role],
      });
      if (response.status === 200) {
        removeAllToasts();
        successToast('User updated successfully!');
        if (onClose) {
          onClose();
        }
        if (onSuccess) {
          onSuccess();
        }
        return;
      }
    } catch (error) {
      errorToast({ error, default: 'Error: Edit User.' });
    }
    setPreventSubmit(false);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Container mb="xs">
        <Title variant="darkGrey" fontWeight="500">
          Edit user
        </Title>
      </Container>
      <Container mb="s">
        <Label htmlFor="firstname" mb="xs">
          First name
        </Label>
        <TextInput
          id="firstname"
          name="firstname"
          variant="minimal"
          placeholder="First name"
          value={state.firstname}
          onChange={handleChange}
          required
          autoFocus
        />
      </Container>
      <Container mb="s">
        <Label htmlFor="lastname" mb="xs">
          Last name
        </Label>
        <TextInput
          id="lastname"
          name="lastname"
          variant="minimal"
          placeholder="Last name"
          value={state.lastname}
          onChange={handleChange}
          required
        />
      </Container>
      <Container mb="s">
        <Label htmlFor="email" mb="xs">
          Email
        </Label>
        <TextInput
          id="email"
          name="email"
          type="email"
          variant="minimal"
          placeholder="Email"
          value={state.email}
          onChange={handleChange}
          required
        />
      </Container>
      <Container mb="s">
        <Label htmlFor="phone" mb="xs">
          Phone
        </Label>
        <TextInput
          id="phone"
          name="phone"
          type="tel"
          variant="minimal"
          pattern={ValidationPattern.phone}
          placeholder="Phone"
          value={state.phone}
          onChange={handleChange}
          required
        />
      </Container>
      <Container mb="m">
        <Label htmlFor="role" mb="xs">
          Role
        </Label>
        <Select
          id="role"
          testId="role"
          placeholder="Role"
          caretColor="primary"
          variant="minimal"
          options={[
            { label: 'Super Admin', value: 'admin' },
            { label: 'User', value: 'user' },
          ]}
          value={state.role}
          onChange={(option) =>
            handleChange({
              target: {
                name: 'role',
                value: option.value,
              },
            })
          }
          required
        />
      </Container>
      <Container flexDirection="row" justifyContent="flex-end" mt="xxs">
        <Button
          variant="contrast-primary"
          width="30%"
          disabled={preventSubmit}
          onClick={onClose}
          boxShadow="none"
          mr="s"
        >
          Close
        </Button>
        <Button type="submit" width="30%" disabled={preventSubmit}>
          Save
        </Button>
      </Container>
    </Form>
  );
};
